import { onCLS, onINP, onLCP } from 'web-vitals';
import type { Metric } from 'web-vitals';
import { asyncInitializedMixpanel } from './asyncMixpanel';
import { MIXPANEL_EVENT } from './events';

interface PageContext {
  page: string;
  networkId: string;
}

export function parsePageContext(pathname: string = window.location.pathname): PageContext {
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length < 2) {
    return { page: '', networkId: '' };
  }

  return {
    networkId: segments[0],
    page: segments[1],
  };
}

async function handleMetric(metric: Metric): Promise<void> {
  const { page, networkId } = parsePageContext();
  const mixpanel = await asyncInitializedMixpanel;

  mixpanel.track(MIXPANEL_EVENT.webVitals.reported, {
    metricName: metric.name,
    value: metric.value,
    delta: metric.delta,
    rating: metric.rating,
    navigationType: metric.navigationType,
    page,
    networkId,
  });
}

let registered = false;

export function _resetForTesting(): void {
  registered = false;
}

export function reportWebVitals(): void {
  if (registered) {
    return;
  }
  registered = true;

  onCLS(handleMetric);
  onINP(handleMetric);
  onLCP(handleMetric);
}
